// extracted by mini-css-extract-plugin
export default {"parcheggi":"Maps_parcheggi__ctntT"};